import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

interface SubscriptionCancelledProps {
  onRetry?: () => void;
  onContinue?: () => void;
}

export function SubscriptionCancelled({ onRetry, onContinue }: SubscriptionCancelledProps) {
  const navigate = useNavigate();

  const handleRetry = () => {
    if (onRetry) {
      onRetry();
    } else {
      navigate('/upgrade');
    }
  };

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
              <XCircle className="w-8 h-8 text-red-600" />
            </div>
          </div>
          <CardTitle className="text-xl">Paiement annulé</CardTitle>
          <CardDescription>
            Vous avez annulé le processus de paiement. Aucun montant n&apos;a été débité.
          </CardDescription>
        </CardHeader>
        
        <CardContent className="space-y-4">
          <div className="text-center text-sm text-muted-foreground">
            <p>Vous pouvez continuer à utiliser votre compte gratuit ou réessayer le paiement plus tard.</p>
          </div>

          <div className="flex flex-col gap-2">
            <Button onClick={handleRetry} className="w-full">
              <CreditCard className="w-4 h-4 mr-2" />
              Réessayer le paiement
            </Button>
            
            <Button variant="outline" onClick={handleContinue} className="w-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Retour au Dashboard
            </Button>
          </div>

          <p className="text-xs text-center text-muted-foreground">
            Vous gardez accès à toutes les fonctionnalités gratuites
          </p>
        </CardContent>
      </Card>
    </div>
  );
}